// Archer ids always carry the "BAID-" prefix. The ADOIT-only import fills the
// same column with the bare ADOIT id, because the Excel upload rejects rows
// without an id, so a non-prefixed id is not proof of an Archer record.
const ARCHER_CUSTOM_ID_PREFIX = "baid-";

export function isArcherCustomId(customId: string | undefined): boolean {
  return Boolean(
    customId?.trim().toLowerCase().startsWith(ARCHER_CUSTOM_ID_PREFIX)
  );
}
